import React, { useState } from 'react';
import { ButtonGroup, IconButton, Tooltip, CircularProgress } from "@mui/material";
import { ViewModule, ViewStream, ViewQuilt, ViewSidebar } from "@mui/icons-material";
import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const LayoutControl = ({ layout, setLayout, onExportImage, onExportPDF, exportLoading = {} }) => {
  return (
    <div className="d-flex justify-content-end pr-3">
      <ButtonGroup size="small" aria-label="export controls" style={{ marginRight: '8px' }}>
        <Tooltip title="Export as Image">
          <IconButton
            onClick={onExportImage}
            disabled={exportLoading.image}
          >
            {exportLoading.image ? <CircularProgress size={16} /> : <ImageIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Export as PDF">
          <IconButton
            onClick={onExportPDF}
            disabled={exportLoading.pdf}
          >
            {exportLoading.pdf ? <CircularProgress size={16} /> : <PictureAsPdfIcon />}
          </IconButton>
        </Tooltip>
      </ButtonGroup>
      <ButtonGroup size="small" aria-label="layout control">
        <Tooltip title="Default View">
          <IconButton
            onClick={() => setLayout("default")}
            color={layout === "default" ? "primary" : "default"}
          >
            <ViewModule />
          </IconButton>
        </Tooltip>
        <Tooltip title="Left Wide View">
          <IconButton
            onClick={() => setLayout("leftWide")}
            color={layout === "leftWide" ? "primary" : "default"}
          >
            <ViewSidebar style={{ height: "21px" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Right Wide View">
          <IconButton
            onClick={() => setLayout("rightWide")}
            color={layout === "rightWide" ? "primary" : "default"}
          >
            <ViewQuilt />
          </IconButton>
        </Tooltip>
        <Tooltip title="Full View">
          <IconButton
            onClick={() => setLayout("full")}
            color={layout === "full" ? "primary" : "default"}
          >
            <ViewStream />
          </IconButton>
        </Tooltip>
      </ButtonGroup>
    </div>
  );
};

export default LayoutControl;
